$(document).ready(function(){
let option;

function variantChange(option_1,option_2,option_3){
    if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 != 'undefined'){
      option = option_1 + " / " + option_2 + " / " + option_3;
    }else{
        if(typeof option_1 != 'undefined' && typeof option_2 == 'undefined' && typeof option_3 == 'undefined'){
            option = option_1;
          }else{
            if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 == 'undefined'){
                option = option_1 + " / " + option_2;
              }
          }
        if(typeof option_1 == 'undefined' && typeof option_2 != 'undefined' && typeof option_3 == 'undefined'){
            option = option_1;
          }else{
            if(typeof option_1 != 'undefined' && typeof option_2 != 'undefined' && typeof option_3 != 'undefined'){
                option = option_2 + " / " + option_3;
              }
          }
        if(typeof option_1 == 'undefined' && typeof option_2 == 'undefined' && typeof option_3 != 'undefined'){
            option = option_1;
          } else{
            if(typeof option_1 != 'undefined' && typeof option_2 == 'undefined' && typeof option_3 != 'undefined'){
                option = option_1 + " / " + option_3;
              }
          }
    }
    // console.log(option)    

    $('.product-detail__content .variant-option-js option').each(function(){
        if($(this).text() == option){
            $(this).prop('selected',true);
            var option_trigger_val = $(this).attr('data-id');
            //change price
           let price = $(this).attr('data-price');
           $('.product-detail__price').text(price);
           let compare_price = $(this).attr('data-compare-price');
           $('.product-compate-at-price').text(compare_price);

           //change available Button
           let is_available = $(this).attr('data-available');
        //    if(is_available == 'true'){
        //     $('.product-detail__atc button').css('background-color','#111').css("pointer-events",'all').text("Add To Cart").addClass('pdp-atc-js')
        //    }else{
        //     $('.product-detail__atc button').css('background-color','#c3c2c2').css("pointer-events",'none').text('Sold Out').removeClass('pdp-atc-js')
        //    }
        }
        $('shopify-payment-terms').attr('variant-id', option_trigger_val);
        $('.product-form__master-select').val(option_trigger_val).trigger("change");
    })


    var prev_selectore = $('.product-detail__content').find('.variant-option-js option:selected').text();    
     var create_arry = [];
    $.each(prev_selectore.split(" / "), function(){
        create_arry.push($.trim(this));
    });    
    $.each(create_arry, function(index, value){          
        $('.product-detail__wood-option__choose input:radio').each(function(){
            var curr_selected_radion = $(this).val();
            if(value == curr_selected_radion){
                $(this).prop('checked', true)
            }
        })
        $('.add-cart-section-2 select option').each(function(){
            var curr_selected_radion = $(this).val();            
            if(value == curr_selected_radion){
                $(this).prop('selected',true);
            }
        })
    })
}


    $(document).on('click','input[name="wood-option-1"]',function(){
        let option_1 = $(this).attr('id');
        let option_2 = $('input[name="wood-option-2"]:checked').attr('id');
        let option_3 = $('input[name="wood-option-3"]:checked').attr('id');
        variantChange(option_1,option_2,option_3);
    });
    $(document).on('click','input[name="wood-option-2"]',function(){
        let option_2 = $(this).attr('id');
        let option_1 = $('input[name="wood-option-1"]:checked').attr('id');
        let option_3 = $('input[name="wood-option-3"]:checked').attr('id');
        variantChange(option_1,option_2,option_3);
    });
    $(document).on('click','input[name="wood-option-3"]',function(){
        let option_3 = $(this).attr('id');
        let option_2 = $('input[name="wood-option-2"]:checked').attr('id');
        let option_1 = $('input[name="wood-option-1"]:checked').attr('id');
        variantChange(option_1,option_2,option_3);
    })



    $(document).on('change','.sticky-add-cart #wood-option-1',function(){
        let option_1 = $(this).find(":selected").attr('id');
        let option_2 = $('.sticky-add-cart #wood-option-2').find(":selected").attr('id');
        let option_3 = $('.sticky-add-cart #wood-option-3').find(":selected").attr('id');
        console.log(option_1,option_2,option_3);      
        variantChange(option_1,option_2,option_3);               
    });
    $(document).on('change','.sticky-add-cart #wood-option-2',function(){
        let option_2 = $(this).find(":selected").attr('id');
        let option_1 = $('.sticky-add-cart #wood-option-1').find(":selected").attr('id');
        let option_3 = $('.sticky-add-cart #wood-option-3').find(":selected").attr('id');
        console.log(option_1,option_2,option_3);
        variantChange(option_1,option_2,option_3);
    });
    $(document).on('change','.sticky-add-cart #wood-option-3',function(){
        let option_3 = $(this).find(":selected").attr('id');        
        let option_2 = $('.sticky-add-cart #wood-option-2').find(":selected").attr('id');
        let option_1 = $('.sticky-add-cart #wood-option-1').find(":selected").attr('id');
        console.log(option_1,option_2,option_3);
        variantChange(option_1,option_2,option_3);
    })

    //on first load change variant
    $('input[name="wood-option-1"]:first').trigger('click')


    // ADD TO CART
    $(document).on('click','.pdp-atc-js',function(){
        event.preventDefault();

        if($(this).parents('.product-detail__content').find('.product-detail__wood-option').hasClass( "product-with-default-variant" )){
            let itemsArray = [];          
            let id =  $('.product-detail__content').find('.variant-option-js option:selected').attr('data-id');
            let singleItem = {id: id, quantity: 1 };
            itemsArray.push(singleItem);
          
            if($('input[name="add-on"]:checked').length > 0){
            let addons_id =  $('input[name="add-on"]').val();
            let offerItem = {id: addons_id, quantity: 1 };
                itemsArray.push(offerItem);
            }

            if($('input[name="add-on-2"]:checked').length > 0){
                let addons_id_2 =  $('input[name="add-on-2"]').val();
                let offerItem = {id: addons_id_2, quantity: 1 };
                    itemsArray.push(offerItem);
            }
    
    console.log(itemsArray)
        $.ajax({
            url : "/cart/add.js",
            data : {items : itemsArray},
            method : "POST",    
            dataType : "JSON",
            success: function(success_data) {
                // console.log("success_data",success_data)
               window.location = '/cart';
            },
            error:function(data){
                window.alert(data.responseJSON.description);
            }
            });  
        }else {
            var radio_selected = $('input[name="wood-option-1"]:checked').val();       
            if( radio_selected.indexOf( 'Without Wood' ) != -1 ){       
                Fancybox.show([{
                    src : "#woodPopup",
                    type : "inline"
                }]);
    
                $(document).on('click','.popup-atc-js',function(){
                    event.preventDefault();
                 let itemsArray = []; 
                   let id =  $('input[name="wantWoodOrNot"]:checked').attr('data-id');
                   let singleItem = {id: id, quantity: 1 };
                   itemsArray.push(singleItem);
                 
                   if($('input[name="add-on"]:checked').length > 0){
                   let addons_id =  $('input[name="add-on"]').val();
                   let offerItem = {id: addons_id, quantity: 1 };
                       itemsArray.push(offerItem);
                   }
                   if($('input[name="add-on-2"]:checked').length > 0){
                    let addons_id_2 =  $('input[name="add-on-2"]').val();
                    let offerItem = {id: addons_id_2, quantity: 1 };
                        itemsArray.push(offerItem);
                }
           
           console.log(itemsArray)
               $.ajax({
                   url : "/cart/add.js",
                   data : {items : itemsArray},
                   method : "POST",    
                   dataType : "JSON",
                   success: function(success_data) {
                       // console.log("success_data",success_data)              
                           window.location = '/cart';              
                   },
                   error:function(data){
                       window.alert(data.responseJSON.description);
                   }
                   });
               })
            }
            else{
            let itemsArray = [];          
            let id =  $('.product-detail__content').find('.variant-option-js option:selected').attr('data-id');
            let singleItem = {id: id, quantity: 1 };
            itemsArray.push(singleItem);
          
            if($('input[name="add-on"]:checked').length > 0){
            let addons_id =  $('input[name="add-on"]').val();
            let offerItem = {id: addons_id, quantity: 1 };
                itemsArray.push(offerItem);
            }
            if($('input[name="add-on-2"]:checked').length > 0){
                let addons_id_2 =  $('input[name="add-on-2"]').val();
                let offerItem = {id: addons_id_2, quantity: 1 };
                    itemsArray.push(offerItem);
            }
    
    console.log(itemsArray)
        $.ajax({
            url : "/cart/add.js",
            data : {items : itemsArray},
            method : "POST",    
            dataType : "JSON",
            success: function(success_data) {
                // console.log("success_data",success_data)
               window.location = '/cart';
            },
            error:function(data){
                window.alert(data.responseJSON.description);
            }
            });            
            }
        }
    })

})

$(document).ready(function() {
    $('.js-enable-sticky').parent().addClass('sticky-header-enable');   
})

if(document.querySelector('.product-detail__atc')) {
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;    
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop() ;    
    var viewportBottom = viewportTop + $(window).height();    
    return viewportTop > elementBottom ; 
  };
  
  $(window).on('resize scroll', function() {
  
      if ($('.js-product-detail-atc-wraper .product-detail__atc').isInViewport()) {
        $('.sticky-add-to-cart-wrapper').css('display','block');
      } 
      else {
        
        $('.sticky-add-to-cart-wrapper').css('display','none');
      }  
  });
}
  $(function() {
    $('a[href*=\\#]:not([href=\\#]).learn_more_link').on('click', function() {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    });
});

